import { Option } from './HierarchyOptions';

export const getIdPath = (options: Option[], value: string, path: string[] = []): string[] => {
  const currentOption = options.find(opt => opt.value === value);
  if (!currentOption) {
    return path;
  }
  const currentPath = [currentOption.value, ...path];
  return !currentOption.parentId ? currentPath : getIdPath(options, currentOption.parentId, currentPath);
};
